module.exports = __webpack_public_path__ + "img/rejected-icon.c57cd1cb.svg";